<template>
  <ul>
    <slot />
  </ul>
</template>

<style lang="postcss" scoped>
ul {
  margin: 1.25em 0;
  list-style-type: disc;
  padding: 0 0 0 1.5rem;

  :deep(ul),
  :deep(ol) {
    margin-top: 0.5em !important;
    margin-bottom: 0.5em !important;
  }
}
</style>
